// extracted by mini-css-extract-plugin
export var growableInput = "_5r-0";
export var tagContainer = "_5r-2";
export var textInput = "_5r-1";